var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaret = function SvgCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.852 1.284a1.825 1.825 0 0 0-1.895-.037C3.367 1.59 3 2.232 3 2.931v14.14c0 .699.367 1.342.957 1.683.59.341 1.316.325 1.895-.036l11.25-7.07c.558-.35.898-.972.898-1.647s-.34-1.294-.898-1.647l-11.25-7.07Z",
    fill: "#fff"
  })));
};
export default SvgCaret;